import { useState } from "react";
import { sanitizeHtml } from "Utils/sanitizeHtml";

const InfoModal = ({
  message,
  show,
  onClose,
  action,
  actionFunction,
  title,
  viewCancel,
  large = false,
}) => {
  if (!show) return null;

  return (
    <>
      <div
        className="modal show"
        style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
      >
        <div
          className={`modal-dialog${large ? ' modal-dialog--large' : ''}`}
        >
          <div className="modal-content p-4">
            <div
              className={`info-message-box mt-3 mb-3 auth-page-info-box${large ? ' info-message-box--large' : ''}`}
            >
              <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0ZM9 3V5H7V3H9ZM6 12V13H10V12H9V6H6V7H7V12H6Z"
                    fill="#008080"
                  />
                </svg>
              </span>
              <div
                className="info-message-holder"
              >
                <p className="success-message pb-2">{title}</p>
                {/*<p className="info-message-text">{message}</p>*/}
                <div
                  className="info-message-text"
                  dangerouslySetInnerHTML={{ __html: sanitizeHtml(message) }}
                />
              </div>
            </div>
            <div className="d-flex justify-content-between">
              {viewCancel && (
                <button
                  className="btn btn-secondary btn-small"
                  onClick={onClose}
                >
                  Cancel
                </button>
              )}
              <button
                className="btn btn-primary btn-small"
                onClick={actionFunction}
              >
                {action}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InfoModal;
